import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBoxColumn, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { TextButton } from '@ecp/common/src/components/button/TextButton';
import Badge from '@ecp/common/src/components/badge/bo/Badge';

import { alarmPopupState, alarmState } from '@bo-recoil/common/alarm/atom';
import CommonApi from '@bo-apis/common/commonApi';
import { ReactComponent as NotificationSvg } from '@bo-assets/icon/common/icon__notification.svg';
import { renderAlarmItem } from '@bo-layout/gnb/GnbAlarmTemplate';
import AlarmDrawer from '@bo-layout/gnb/alarm/AlarmDrawer';

const AlarmItem = ({ item }) => {
  return (
    <FlexBoxColumn
      width={'100%'}
      align-items={'flex-start'}
      style={{ color: item?.confirmYn === 'Y' ? '#a3a3a3' : '#141415', boxSizing: 'border-box' }}
      padding={'0 10px'}
    >
      <FlexBoxSpaceBetween width={'100%'}>{renderAlarmItem(item)}</FlexBoxSpaceBetween>
    </FlexBoxColumn>
  );
};

AlarmItem.propTypes = {
  item: PropTypes.object,
};

const AlarmPopup = ({ items, floatingRef }) => {
  return (
    <>
      {items.map((item, index) => (
        <AlarmItem key={`key-${index}`} item={item} floatingRef={floatingRef} />
      ))}
      <TextButton width={'100%'} type={'move'} style={{ justifyContent: 'center' }}>
        알림 더 보기
      </TextButton>
    </>
  );
};

AlarmPopup.displayName = 'AlarmPopup';

AlarmPopup.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
  floatingRef: PropTypes.object,
};

const GnbAlarm = () => {
  const [items, setItems] = useRecoilState(alarmState);
  const [isPopupOpen, setPopupOpen] = useRecoilState(alarmPopupState);

  const unreadCount = useMemo(() => {
    return items?.reduce((acc, curr) => {
      return Math.min(acc + curr.moreCount, 999);
    }, 0);
  }, [items]);

  const getMyAlarms = async () => {
    const { result = [] } = await CommonApi.getMyAlarms();
    return result;
  };

  const location = useLocation();
  useEffect(() => {
    (async () => {
      const alarms = await getMyAlarms();
      setItems(alarms);
    })();
  }, [location, setItems, isPopupOpen]);

  const handleOnDrawerClose = () => {
    setPopupOpen(false);
  };

  const handleOnBadgeClick = () => {
    setPopupOpen(!isPopupOpen);
  };

  return (
    <>
      <Badge
        showZero={false}
        position={{ top: '-8px', left: '10px' }}
        badgeContent={unreadCount}
        max={999}
        onClick={handleOnBadgeClick}
      >
        <AlarmIcon />
      </Badge>
      <AlarmDrawer isDrawerOpen={isPopupOpen} onDrawerClose={handleOnDrawerClose} />
    </>
  );
};

GnbAlarm.displayName = 'GnbAlarm';

GnbAlarm.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};

GnbAlarm.defaultProps = {
  items: [],
};

export default GnbAlarm;

const AlarmIcon = styled(NotificationSvg)`
  cursor: pointer;
  width: 20px;
  height: 22px;
  display: flex;
  align-items: center;
`;
